import { put } from 'redux-saga/effects';

import { authUserModel } from '../../../entities/auth-user';

export function* clearData() {
  yield put(authUserModel.actions.setUser(undefined));
}
